import cmp from './UserNotAuthorized'

export default cmp
